export default __webpack_public_path__ + "static/silverringwithdifferentmeaurements-6ca178c87789ca5d738999021791eb70.png";